import React from 'react'
import { useState } from 'react'
import Navigation from './Navigation'
import { Link } from 'react-router-dom'

const Header = () => {

  const [headerClass, setHeaderClass] = useState(false)
  const [openMenus, setOpenMenus] = useState({});

  const openNav = () => {
    setHeaderClass(true);
  }
  const closeNav = () => {
    setOpenMenus({});
    setHeaderClass(false);
  }
  const toggleMenu = (menuId) => {
    setOpenMenus(() => {
      const newState = {};
      newState[menuId] = !openMenus[menuId];
      return newState;
    });
  };


  return (
    <header className={ headerClass ? 'open' : ''}>
      <span className='close_btn' 
            onClick={ closeNav }
            aria-label='메뉴 닫기'
            role='button'>
        <svg className='close_btn' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ><path className="secondary" fillRule="evenodd" d="M15.78 14.36a1 1 0 0 1-1.42 1.42l-2.82-2.83-2.83 2.83a1 1 0 1 1-1.42-1.42l2.83-2.82L7.3 8.7a1 1 0 0 1 1.42-1.42l2.83 2.83 2.82-2.83a1 1 0 0 1 1.42 1.42l-2.83 2.83 2.83 2.82z"/></svg>
      </span>   
      <span className='open_btn' 
            onClick={ openNav }
            aria-haspopup='menu'
            aria-label='메뉴 열기'
            role='button'>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-8 mr-4 icon-menu"><path className="secondary" fillRule="evenodd" d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"/></svg>
      </span>
      <Navigation toggleMenu={ toggleMenu }
                  openMenus={ openMenus } 
                  setOpenMenuspenMenus={ setOpenMenus } 
                  closeNav={ closeNav }
                  aria-hidden={ headerClass ? false : true} />
      
      <div className='close' onClick={ closeNav }></div>
      <h1><Link to='/' onClick={ closeNav }>
        <img src={`${process.env.PUBLIC_URL}/img/logo_toolkit_color_onlyimg.png`} alt="성별정정툴킷 로고" />
        <span>성별정정툴킷</span>
        </Link></h1>
      <div  className='contact'
            aria-label='문의 페이지' >
        <Link to='/contact' onClick={ closeNav }>문의</Link>
      </div>
    </header>
  )
}

export default Header
